export default {
  read: {
    title: "Data",
    subtitle: "Data and statistics",
    income: "Income",
    totalIncome: "Total income",
    incomeOverTime: "Income over time",
    createdProjects: "projects created",
    newEvents: "total events",
    newCourses: "total courses",
    totalPartners: "members",
    newDonations: "total donations",
    collected: "Raised this month",
    currentCollected: "raised - 5% for Lazzaro",
    withdraw: "Withdraw",
    totalDonors: "No. of donors",
    labels: {
      projects: "Projects",
      events: "Events",
      courses: "Courses",
      partners: "Members",
      donations: "Donations"
    }
  }
};
